import { Loader2 } from "lucide-react";

/**
 * Loading fallback component for Suspense boundaries
 * Displays a centered loading spinner matching the app theme
 */
export default function LoadingFallback() {
  return (
    <div className="min-h-screen bg-background flex items-center justify-center">
      <div className="flex flex-col items-center gap-4">
        <Loader2 className="w-5 h-5 text-primary animate-spin" />
        <p className="text-muted text-sm">Loading...</p>
      </div>
    </div>
  );
}
